import { experimental_createPersister } from '@tanstack/query-persist-client-core'
import { get, set, del } from 'idb-keyval'

const BUSTER_KEY = 'query-persister-buster'

/**
 * Invalidate every IDB-persisted query snapshot on next restore.
 * The persister only compares a restored entry's own age against staleTime -
 * it never checks the live QueryClient's invalidateQueries state - so a
 * server-side data change (e.g. scenario refresh) can leave a persisted
 * snapshot that looks "fresh enough" and gets served without a refetch.
 * Bumping the buster makes createIdbPersister() calls after this point
 * treat any previously-persisted entry as busted, forcing a real fetch.
 */
export function bumpPersisterBuster() {
  localStorage.setItem(BUSTER_KEY, String(Date.now()))
}

export function createIdbPersister() {
  return experimental_createPersister({
    storage: {
      getItem: (key) => get(key),
      setItem: (key, value) => {
        return set(key, value)
      },
      removeItem: (key) => del(key)
    },
    //default serialization assumes that the values need to be stored as strings for localStorage
    //this is not required for IndexedDB, so we can just pass through the data
    // serialize: (data) => data,
    // deserialize: (data) => data,
    buster: localStorage.getItem(BUSTER_KEY) || '',
    maxAge: 1000 * 60 * 60 * 48 // 48 hours
  })
}
